import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { useProgress } from '../../store'

/** ProgressBar displaying according to 'progress' value from the store */
const Progress = () => {
  const progress = useProgress()
  return progress >= 0 ? (
    <ProgressBar>
      <ProgressBar aria-label='loading' animated now={progress} />
    </ProgressBar>
  ) : null
}

export { Progress }
